import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  link: FelaCSS;
  iconWrapper: FelaCSS;
  icon: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    borderRadius: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 4,
    height: '100%',
  },
  link: {
    height: '100%',
    fontDefaultSemiBold: 16,
  },
  iconWrapper: {
    gap: 10,
    alignItems: 'center',
    flexDirection: 'row',
  },
  icon: {
    display: 'flex',
    borderRadius: '100%',
    border: `1px solid ${colors.space08}`,
    backgroundColor: colors.white,
    width: '38px',
    height: '38px',
    justifyContent: 'center',
    hover: undefined,
    active: undefined,
  },
});

export default styles;
